<template>
  <v-main class="favorite_list">
    <div>
      <v-text-field
        v-model="name"></v-text-field>

      <v-btn small
             dense
             outlined
             class="option"
             color="blue"
             @click="$emit('updateList', {id: favorite_list.id, name: name})"
      >
        Update list
      </v-btn>
      <v-btn small
             dense
             outlined
             class="option"
             color="red"
             @click="$emit('deleteList', {id: favorite_list.id, index: child_number})"
      >
        Delete list
      </v-btn>
      <v-btn small
             outlined
             dense
             class="option"
             color="green"
             @click="addRestaurantToggled = !addRestaurantToggled"
      >
        Add a restaurant
        <v-icon v-if="!addRestaurantToggled">mdi-chevron-down</v-icon>
        <v-icon v-else>mdi-chevron-up</v-icon>
      </v-btn>
    </div>

    <div v-show="addRestaurantToggled">
      <div class="restaurant ml-4" v-for="(restaurant, index) in restaurantsList" :key="index">
         {{restaurant.name}}
        <v-spacer></v-spacer>
        <v-btn small outlined color="green"
        @click="addRestaurant(index)"> Add</v-btn>
      </div>
    </div>

    <v-container class="grid" v-if="restaurants.length !== 0">
      <RestaurantFavoriteCard v-for="(restaurant, index) in restaurants" :key="index"
                              :child_number="index"
                              :ref="index"
                              :restaurant_id="restaurant.id"
                              :favorite_list_id="favorite_list.id"
                              @deleteRestaurant="deleteRestaurant"/>
    </v-container>

    <div v-else class="font-italic">
      No added restaurant yet to this list.
    </div>
  </v-main>
</template>

<script>
import Api from "@/services/api";
import RestaurantFavoriteCard from "@/components/Favorites/RestaurantFavoriteCard";

export default {
  name: "FavoriteList",
  components: {
    RestaurantFavoriteCard
  },

  data() {
    return {
      name: "",
      restaurants: "",
      addRestaurantToggled:false,
    }
  },

  props: [
    'child_number',
    'favorite_list',
    'restaurantsList',
    'onAddRestaurantToList',
    'onDeleteRestaurantFromList'
  ],

  methods: {
    destroyElement() {
      // Destroy method
      console.log(`destroy ${this.name}`)
      this.$destroy();
      this.$el.remove();
    },

    async deleteRestaurant(payload) {
      await this.onDeleteRestaurantFromList(this.favorite_list.id, payload.id)
      this.$refs[payload.index][0].destroyElement();
    },

    async addRestaurant(restaurant_index){
      const id= this.restaurantsList[restaurant_index]['id'] //restaurantId
      await this.onAddRestaurantToList(this.favorite_list.id, id)

      this.$eventHub.$emit('reloadAll')

    }
  },

  async created() {
    this.api = new Api()
    this.name = this.favorite_list.name
    this.restaurants = this.favorite_list.restaurants

  }
}
</script>

<style scoped>
.favorite_list {
  -webkit-box-shadow: 0 0 10px grey;
  box-shadow: 0 0 10px grey;

  margin: 3vh;
  border-radius: 6px;
}

.option {
  margin: 0.5vw;
}

.restaurant{
  display: flex;
  width: 50%;
  flex-direction: row;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 24%);
  grid-gap: 15px;
}

@media screen and (max-width: 1024px) {
  .grid {
    grid-template-columns: repeat(3, 33%);
  }
}

@media screen and (max-width: 768px) {
  .grid {
    grid-template-columns: repeat(2, 49%);
  }
}

@media screen and (max-width: 480px) {
  .grid {
    grid-template-columns: 100%;
  }
}
</style>
